var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isEmpty)?_c('img',{attrs:{"src":require("@/assets/img/placeholders/pie-chart-placeholder.svg"),"alt":"pie chart placeholder"}}):_c('vue-apex-charts',{ref:"chart",attrs:{"type":"donut","height":_vm.height,"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }